import * as Yup from 'yup';

export const priceListSchema = Yup.object({
  Price: Yup.string()
    .required('Price is required'),
  KitDescription: Yup.string().required('Description is required'),
  Quantity: Yup.string()
    .required('Quantity is required'),
});
